import { ERROR, SUCCESS } from "../constants/types/alertType";
import {
  PENDING_PRACTITIONER_RECEIVED,
  PRACTITIONER_LIST_RECEIVED,
  PRACTITIONER_SEARCH_LIST_RECEIVED,
  PRACTITIONER_LIST_RECEIVED_FOR_ADMIN,
} from "../constants/types/practitionerType";
import axios from "../utils/axios";

export const practitionerSavePatient = (data, callback) => (dispatch) => {
  axios.get(`practitionerPatientConnect?${data}`).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getPendingPractitioners = () => (dispatch) => {
  axios.get("patientPractitionerConnect?action=getPractitionersPending").then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: PENDING_PRACTITIONER_RECEIVED,
          payload: resp.data.practitionerList,
        });
      } else {
        dispatch({
          type: PENDING_PRACTITIONER_RECEIVED,
          payload: [],
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const acceptOrRejectPractitioner =
  (actionName, Id, callback) => (dispatch) => {
    axios
      .get(`patientPractitionerConnect?action=${actionName}&ppc_id=${Id}`)
      .then(
        (resp) => {
          if (resp.data) {
            dispatch({
              type: SUCCESS,
              payload: resp.data.message,
            });
            callback && callback();
          } else {
            dispatch({
              type: ERROR,
              payload: resp.data.error,
            });
          }
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
        }
      );
  };

export const getPractitionerList = (callback) => (dispatch) => {
  axios.get("patientPractitionerConnect?action=getPractitioners").then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: PRACTITIONER_LIST_RECEIVED,
          payload: resp.data.practitionerList,
        });
      } else {
        dispatch({
          type: PRACTITIONER_LIST_RECEIVED,
          payload: [],
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const getPractitionerListForAdmin = (callback) => (dispatch) => {
  axios.get("analyticsAdmin?action=getAdminPractitioners").then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: PRACTITIONER_LIST_RECEIVED_FOR_ADMIN,
          payload: resp.data.practiitonerList,
        });
      } else {
        dispatch({
          type: PRACTITIONER_LIST_RECEIVED_FOR_ADMIN,
          payload: [],
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const adminAction = (data, callback) => (dispatch) => {
  axios.post(`analyticsAdmin`, data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback(resp.data);
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        callback && callback();
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      callback && callback();
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getSearchPractitionerList = (callback) => (dispatch) => {
  axios.get("patientPractitionerConnect?action=patientSearchPractitioner").then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: PRACTITIONER_SEARCH_LIST_RECEIVED,
          payload: resp.data,
        });
        callback && callback();
      } else {
        dispatch({
          type: PRACTITIONER_SEARCH_LIST_RECEIVED,
          payload: [],
        });
        callback && callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const toggleShareWithPractitioner =
  (actionName, Id, callback) => (dispatch) => {
    axios
      .get(`patientPractitionerConnect?action=${actionName}&ppc_id=${Id}`)
      .then(
        (resp) => {
          if (resp.data) {
            dispatch({
              type: SUCCESS,
              payload: resp.data.message,
            });
            callback && callback();
          } else {
            dispatch({
              type: ERROR,
              payload: resp.data.error,
            });
          }
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
        }
      );
  };

export const invitePractitioner = (Id, callback) => (dispatch) => {
  axios
    .get(
      `patientPractitionerConnect?action=patientInvitesPractitioner&user_id_practitioner=${Id}`
    )
    .then(
      (resp) => {
        if (resp.data) {
          dispatch({
            type: SUCCESS,
            payload: resp.data.message,
          });
          callback && callback();
        } else {
          dispatch({
            type: ERROR,
            payload: resp.data.error,
          });
        }
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
      }
    );
};
